import AdherenceChartNew from "../../../nutrition/components/AdherenceChartNew";
import AdherenceChartNewMobile from "../../../nutrition/components/AdherenceChartNewMobile";
import LegendItem from "../../../nutrition/components/LegendItem";
import { getAverageStats } from "../../../../../utils/nutrition-helpers";
import AdherenceStats from "../../../nutrition/components/AdherenceStats";
import { filterNutrients } from "../body-composition.helper";
import NoData from "./NoData";
import SvgIcon from "../../../../../parts/SvgIcon";

const Header = ({ athlete, organizationCoachParam }) => (
  <header>
    <div>
      <h4>Nutrition</h4>
      <p className="p4">(average for week)</p>
    </div>
    <a
      className="composition-see-more mobile-hidden"
      href={`/athlete-portal/nutrition/?athlete=${athlete}${organizationCoachParam}`}
    >
      <span>See more</span>
      <SvgIcon
        src="/img/new-icons/arrow-square-right-gradient.svg"
        noFilterOnLight={true}
      />
    </a>
  </header>
);

const noBgColor = { backgroundColor: "transparent" };

const NutritionStats = ({
  dateFrom,
  dateTo,
  stats,
  date,
  athlete,
  calendarDay,
  nutritionPlans,
  organizationCoachParam,
  activeExercises,
}) => {
  const statsWithNutrients = stats.filter(({ nutrients }) => !!nutrients);

  return (
    <article id="nutrition">
      <Header
        date={date}
        athlete={athlete}
        organizationCoachParam={organizationCoachParam}
      />
      <div className="composition-nutrition-content">
        <AdherenceStats
          dateFrom={dateFrom}
          dateTo={dateTo}
          stats={statsWithNutrients}
          dataView={"avg"}
          nutritionPlans={nutritionPlans}
          activeExercises={activeExercises}
        />

        <div
          className="composition-nutrition-bottom nutrition-adherence"
          style={noBgColor}
        >
          <div className="adherence-chart-new">
            {statsWithNutrients.length ? (
              <>
                <div className="mobile-hidden">
                  <AdherenceChartNew
                    stats={statsWithNutrients}
                    dateFrom={dateFrom}
                    dateTo={dateTo}
                    averageStats={getAverageStats(
                      dateFrom,
                      dateTo,
                      calendarDay,
                      stats
                    )}
                    nutritionPlans={nutritionPlans}
                    activeExercises={activeExercises}
                  />
                </div>
                <div className="only-show-mobile">
                  <AdherenceChartNewMobile
                    stats={statsWithNutrients}
                    dateFrom={dateFrom}
                    dateTo={dateTo}
                    averageStats={getAverageStats(
                      dateFrom,
                      dateTo,
                      calendarDay,
                      stats
                    )}
                    nutritionPlans={nutritionPlans}
                    activeExercises={activeExercises}
                  />
                </div>
              </>
            ) : (
              <NoData />
            )}
          </div>
        </div>
        <a
          className="composition-see-more only-show-mobile"
          href={`/athlete-portal/nutrition/?athlete=${athlete}${organizationCoachParam}`}
        >
          <span className="only-show-mobile">See more</span>
          <SvgIcon
            src="/img/new-icons/arrow-square-right-gradient.svg"
            noFilterOnLight={true}
          />
        </a>
      </div>
    </article>
  );
};

export default NutritionStats;
